import {
  ExternalSlideStorageBrowseRequest,
  ExternalSlideStorageBrowseResult,
  ExternalSlideTransferJobCreateRequest,
  ExternalSlideTransferJobCreateResult,
  ExternalSlideTransferPreflightResult,
} from 'interfaces/externalStorage';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

const externalSlideStorageUrl = (studyId: string, providerName: string) =>
  `studies/${studyId}/external-slides-storage/${encodeURIComponent(providerName)}`;

export const browseExternalSlideStorage = (
  studyId: string,
  providerName: string,
  data: ExternalSlideStorageBrowseRequest,
  signal?: AbortSignal
) =>
  apiRequestHandlerPromise<ExternalSlideStorageBrowseResult>({
    url: externalSlideStorageUrl(studyId, providerName),
    method: 'POST',
    data: JSON.stringify(data),
    signal,
  });

export const createExternalSlideTransferJob = (
  studyId: string,
  providerName: string,
  data: ExternalSlideTransferJobCreateRequest
) =>
  apiRequestHandlerPromise<ExternalSlideTransferJobCreateResult>({
    url: `${externalSlideStorageUrl(studyId, providerName)}/transfer-jobs`,
    method: 'POST',
    data: JSON.stringify(data),
  });

export const preflightExternalSlideTransferJob = (
  studyId: string,
  providerName: string,
  data: ExternalSlideTransferJobCreateRequest
) =>
  apiRequestHandlerPromise<ExternalSlideTransferPreflightResult>({
    url: `${externalSlideStorageUrl(studyId, providerName)}/transfer-jobs/preflight`,
    method: 'POST',
    data: JSON.stringify(data),
  });
